import { differenceInDays } from "date-fns";

export function getFatorVencimento(vencimento: string | Date) {
  vencimento = new Date(vencimento);
  if (vencimento >= new Date(2025, 1, 22)) {
    return differenceInDays(new Date(vencimento), new Date(2022, 4, 29)).toString();
  } else {
    return differenceInDays(new Date(vencimento), new Date(1997, 9, 7)).toString();
  }
}
